import * as React from 'react';
import { ErrorBoundary } from './ErrorBoundary';

const BuggyCounter: React.FC = () => {
  const [counter, setCounter] = React.useState(0);

  if (counter === 5) {
    throw new Error('Simulated error at count 5!');
  }

  return <button onClick={() => setCounter((c) => c + 1)}>Count: {counter} (Throws at 5)</button>;
};

export const ErrorBoundaryTest: React.FC = () => {
  return (
    <div style={{ padding: '20px' }}>
      <h2>Error Boundary Test</h2>
      <ErrorBoundary id="test-counter" name="CounterBoundary">
        <BuggyCounter />
      </ErrorBoundary>
    </div>
  );
};
